export const HeaderUser = function(userClass) {
  /** Получаем блок user */
  const userContainer = document.querySelector(`.${userClass}`)

  /** Если блок user присутствует на странице */
  if (userContainer) {
    document.addEventListener('click', function(event) {
      /** Если событие клик произошло на блоке user*/
      if (event.target.closest(`.${userClass}`)) {
        /** Прячем/Показываем подменю */
        event.target.closest(`.${userClass}`).classList.add('active')
      }
      else if (!event.target.closest('.js-user-menu') && userContainer.classList.contains('active')) {
        userContainer.classList.remove('active')
      }
    })
  }
}